// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(max-width: 576px){.container[data-v-1bc020a1]{flex-direction:column}}.section_image img[data-v-1bc020a1]{width:453px}@media(max-width: 768px){.section_image img[data-v-1bc020a1]{width:268px}}.section_text[data-v-1bc020a1]{flex:1 0 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
